var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    { staticClass: "white", attrs: { errors: _vm.errors } },
    [
      _c("v-container", { staticClass: "flex justify-center align-start" }, [
        _c(
          "div",
          { staticClass: "flex-col" },
          [
            _c("VueLottiePlayer", {
              staticStyle: { width: "inherit", height: "300px" },
              attrs: {
                path: "https://assets3.lottiefiles.com/packages/lf20_no08B3.json",
                background: "transparent",
                speed: "1",
                loop: "",
                autoplay: "",
              },
            }),
            _vm._v(" "),
            _c("v-card-title", { staticClass: "soli-grey justify-center" }, [
              _vm._v("We got your message!"),
            ]),
            _vm._v(" "),
            _c(
              "v-card-subtitle",
              {
                staticClass: "soli-grey",
                staticStyle: {
                  "text-align": "center",
                  "white-space": "pre-line",
                },
              },
              [
                _vm._v(
                  "We’re excited to talk to you more about music lessons.\n                You’ll get an email with helpful links right away, and one\n                of our teachers will be in touch shortly."
                ),
              ]
            ),
            _vm._v(" "),
            _c("SoliBtn", {
              staticClass: "justify-center w-full",
              attrs: {
                text: "Return Home",
                href: _vm.route("login"),
                gradient: "gradient-blue",
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }